<h2 class="mat-h2">Market and patient share</h2>

<table class="firstCol40">
  <tr>
    <th></th>
    <th>Total # patients</th>
    <th [matTooltip]="momentumShortDesc">Δ 4 month</th>
    <th [matTooltip]="momentumLongDesc">Δ PY</th>
  </tr>
  <ng-container *ngIf="marketAndPatientShare; else directSalesNoData">
    <tr>
      <td>{{ getProjectName() }}</td>
      <td class="center">{{ marketAndPatientShare.directSales.total }}</td>
      <td class="center"><ng-container *ngIf="marketAndPatientShare.directSales.fourMonth">{{ marketAndPatientShare.directSales.fourMonth }}%</ng-container><ng-container *ngIf="!marketAndPatientShare.directSales.fourMonth">0%</ng-container></td>
      <td class="center"><ng-container *ngIf="marketAndPatientShare.directSales.py">{{ marketAndPatientShare.directSales.py }}%</ng-container><ng-container *ngIf="!marketAndPatientShare.directSales.py">0%</ng-container></td>
    </tr>
    <tr *ngFor="let competitor of marketAndPatientShare.competitors; let i = index">
      <td>{{ competitor.name }}</td>
      <td class="center">{{ competitor.total }}</td>
      <td class="center"><ng-container *ngIf="competitor.fourMonth">{{ competitor.fourMonth }}%</ng-container><ng-container *ngIf="!competitor.fourMonth">0%</ng-container></td>
      <td class="center"><ng-container *ngIf="competitor.py">{{ competitor.py }}%</ng-container><ng-container *ngIf="!competitor.py">0%</ng-container></td>
    </tr>
  </ng-container>
  <ng-template #directSalesNoData>
    <tr>
      <td colspan="4" class="center">No data available</td>
    </tr>
  </ng-template>
</table>

<!--
<table class="firstCol40">
  <tr>
    <th></th>
    <th>Total # National</th>
    <th>Total # Territory</th>
  </tr>
  <ng-container *ngIf="marketAndPatientShare$ | async as marketAndPatientShare; else patientsIcdNoDataNoData">
    <tr>
      <td>Patients ICD</td>
      <td class="center">{{ marketAndPatientShare.patientsIcd.totalNational }}</td>
      <td class="center">{{ marketAndPatientShare.patientsIcd.totalTerritory }}</td>
    </tr>
    <tr>
      <td>Utilisation per ICD Patient</td>
      <td class="center">{{ marketAndPatientShare.utilisationPerPatient.totalNational }}</td>
      <td class="center">{{ marketAndPatientShare.utilisationPerPatient.totalTerritory }}</td>
    </tr>
  </ng-container>
  <ng-template #patientsIcdNoDataNoData>
    <tr>
      <td colspan="3" class="center">No data available</td>
    </tr>
  </ng-template>
</table>
-->
